export const deepClone = (input) =>
  input === undefined ? input : JSON.parse(JSON.stringify(input));
